import { render, staticRenderFns } from "./PdokAddressTypeahead.vue?vue&type=template&id=57dd7196"
import script from "./PdokAddressTypeahead.vue?vue&type=script&lang=js"
export * from "./PdokAddressTypeahead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports